export default "__VITE_ASSET__f09246bf__"